import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  UpdateCardIssuePointOpts,
  AppAuthService,
  CardIssuePoint,
  CardIssuePointsService,
  Id,
  MunicipalEntitiesService,
  UsersService,
  AddressSuggesterService,
} from '@prodcard/core'
import { CardHeader } from '../../../../components'
import CardIssuePointForm from './CardIssuePointForm.vue'
import { callSuccessToast, createCtx, handleError } from '../../../../helpers'
import { isEmpty, isEqual, pickBy } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardIssuePointEditPage',
  props: {
    authService: {},
    usersService: {},
    municipalEntitiesService: {},
    cardIssuePointsService: {},
    addressSuggesterService: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()

const cardIssuePoint = ref<CardIssuePoint>()
const loading = ref(false)
const disabled = ref(false)

const submit = (opts: UpdateCardIssuePointOpts) => {
  handleError(async () => {
    const aggregateOpts = pickBy(opts, (val, key) => {
      if (!val && !cardIssuePoint.value?.[key as keyof CardIssuePoint]) return false
      if (!isEqual(cardIssuePoint.value?.[key as keyof CardIssuePoint], val)) return true
      return !val
    })

    if (isEmpty(aggregateOpts)) return
    await props.cardIssuePointsService.update(createCtx(), props.id, aggregateOpts)
    callSuccessToast('Данные пункта выдачи карт сохранены')
    router?.back()
  }, loading)
}

handleError(async () => {
  cardIssuePoint.value = await props.cardIssuePointsService.findById(createCtx(), props.id)
}, disabled)

const deleteCardIssuePoint = (id: Id) => {
  handleError(async () => {
    await props.cardIssuePointsService.delete(createCtx(), id)
    router?.back()
    callSuccessToast('Пункт выдачи карт удален')
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    loading: loading.value || disabled.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode(" Редактирование пункта выдачи карт ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          (cardIssuePoint.value && !disabled.value)
            ? (_openBlock(), _createBlock(CardIssuePointForm, {
                key: 0,
                "address-suggester-service": _ctx.addressSuggesterService,
                "auth-service": _ctx.authService,
                "users-service": _ctx.usersService,
                "card-issue-point": cardIssuePoint.value,
                "card-issue-points-service": _ctx.cardIssuePointsService,
                "municipal-entities-service": _ctx.municipalEntitiesService,
                loading: loading.value,
                disabled: disabled.value,
                onSubmit: submit,
                onDelete: deleteCardIssuePoint
              }, null, 8, ["address-suggester-service", "auth-service", "users-service", "card-issue-point", "card-issue-points-service", "municipal-entities-service", "loading", "disabled"]))
            : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 1,
                type: "heading@10, actions"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})